import { ReactElement } from "react";
import { UiLOneColumn } from "@rotorstudios/fe-ui";

import { UiDynamicRenderer } from "../../_common/modules/fe-ui/UiDynamicRenderer";
import useFinance from "./useFinance";

import "./_Finance.scss";

const Finance = (): ReactElement => {
  const { headerContent, mainContent, footerContent } = useFinance();

  const getHeaderContent = () => <UiDynamicRenderer data={headerContent} />;

  const getMainContent = () => <UiDynamicRenderer data={mainContent} />;

  const getFooterContent = () => <UiDynamicRenderer data={footerContent} />;

  return (
    <div className="Finance">
      <UiLOneColumn
        headerContent={getHeaderContent()}
        mainContent={getMainContent()}
        footerContent={getFooterContent()}
      />
    </div>
  );
};

export default Finance;
